<template>

<div class="main list-view no-sub-header">

	<div class="filters">

		<div v-if="showDetail">
			<button :class="['button', userCanEdit ? 'action' : 'disabled']" @click="saveItem()">Save Reason Code</button>
			<button class="button neutral" @click="backToList()">Back To List</button>
		</div>
		<div v-else>
			<ul class="checkbox-group">
				<li>
					<span :class="['pointer', 'far', filters.include_inactive ? 'fa-check-square' : 'fa-square']" @click="toggleFilter('include_inactive')"></span>
					<label>Include Inactive</label>
				</li>
			</ul>
			<div class="divider"></div>
			<button class="button neutral" @click="getItem({})">Add Reason Code</button>
			<div class="divider"></div>
			<div :class="['extra-menu-item', loading ? 'disabled' : '']" @click="doExport()">Export CSV</div>
		</div>
	</div>

	<div v-if="showDetail" class="detail" style="max-width: 20em;">
        <label>Code</label>
		<input type="text" v-model="listDetail.reason_code" :readonly="!userCanEdit" />
        <label>Description</label>
		<input type="text" v-model="listDetail.description" :readonly="!userCanEdit" />
		<div class="v-spaced">
			<checkbox v-model="listDetail.internal_use_only" :disabled="!userCanEdit" label="Hidden" :key="'internal_use_only' + listDetail.internal_use_only" />
		</div>
		<div class="v-spaced">
			<checkbox v-model="listDetail.inactive" :disabled="!userCanEdit" label="Inactive" :key="'inactive' + listDetail.inactive" />
		</div>
		<div v-if="!userCanEdit" class="v-spaced note"><i class="fas fa-ban"></i> This is a system reason code and cannot be edited.</div>
	</div>

	<div v-else class="list report-list">

	    <div v-if="list.length == 0" class="empty-list">
	        This list is empty
	    </div>

		<div v-else>
			<div class="detail-sub-header right">
				<pagination v-if="showPagination" :paging="paging" @updatePage="goToPage"></pagination>
			</div>

			<table class="data-list" cellpadding="0" cellspacing="0">
				<thead>
					<tr>
						<th class="list left">Code</th>
						<th class="list left">Description</th>
						<th class="list center">Hidden</th>
						<th class="list center">Inactive</th>
						<th class="list center">Editable</th>
					</tr>
				</thead>
				<tr v-for="item in list" class="clickable-list-item" @click="getItem(item)">
					<td class="list left">{{ item.reason_code }}</td>
					<td class="list left">{{ item.description }}</td>
					<td class="list center"><i v-if="item.internal_use_only" class="fa fa-check"></i></td>
					<td class="list center"><i v-if="item.inactive" class="fa fa-check"></i></td>
					<td class="list center"><i v-if="item.client_id" class="fa fa-check"></i></td>
				</tr>
			</table>
		</div>
	</div>

	<message-modal v-if="message" :message="message" :loading="loading" :errorStatus="messageStatus" :timeout="messageTimeout" @dismiss="message = ''" />

	<iframe id="download" src="" style="display: none;"></iframe>

</div>

</template>

<script>
import Checkbox from '@/components/Checkbox.vue'
export default {
	name: 'reason-codes',
    components: {
		'checkbox': Checkbox
    },
	data() {
		return {
            loading: false,
			saving: false,
            message: '',
            messageStatus: '',
            messageTimeout: 0,
            list: [],
			paging: {},
			showPagination: true,
            filters: {},
            showDetail: false,
			listDetail: {},
			gettingExport: false,
		}
	},
	created() {
		this.clearFilters(true)
	},
	computed: {
		userCanEdit() {
			return (this.listDetail.reason_code_id && this.listDetail.client_id) || !this.listDetail.reason_code_id
		}
	},
	methods: {
		clearFilters(getList) {
			this.filters = {
				page: 1,
				include_inactive: false,
				do_export: false
			}
			if (getList) {
				this.getList()
			}
		},
		toggleFilter(which) {
			this.filters[which] = !this.filters[which]
			this.getList()
		},
		getList() {
            if (this.loading) { return }
			this.loading = true
			if (this.filters.do_export) {
				this.message = 'Generating CSV for ' + this.list.length + ' items...'
			} else {
				this.message = 'Getting list...'
			}
			this.apiCall({ destination: 'get_list_pos_reason_codes', data: this.filters }).then(obj => {
				this.loading = false
				this.messageStatus = obj.status
				if (this.filters.do_export) {
					this.filters.do_export = 0
					// accommodate live server filecache latency
					setTimeout(() => {
						this.message = 'Downloading CSV...'
						document.getElementById("download").src = obj.download_url
						this.messageTimeout = 2000
					}, 500)
				} else {
					this.message = obj.message
					this.list = obj.list
				}
			}).catch(err => {
				console.log(err)
			})
		},
		doExport() {
			this.filters.do_export = true
			this.getList()
		},
		getItem(item) {
			this.listDetail = item
			this.showDetail = true
		},
		saveItem() {
			if (this.saving) { return }
			this.message = ''
			this.messageStatus = ''
			if (this.listDetail.reason_code == '') {
				this.message = 'Please enter a code.'
				this.messageStatus = 'invalid'
				return
			}
			if (this.listDetail.description == '') {
				this.message = 'Please enter a description.'
				this.messageStatus = 'invalid'
				return
			}
			this.saving = true
			this.message = 'Saving reason code...'
			this.apiCall({ destination: 'save_item_pos_reason_code', data: this.listDetail }).then(obj => {
				this.saving = false
				this.messageStatus = obj.status
				if (obj.status == 'success') {
					this.message = 'Reason code saved!'
					this.messageTimeout = 1500
				} else {
					this.message = obj.message
				}
			}).catch(err => {
				console.log(err)
			})

		},
		goToPage(page) {
			this.filters.page = page
			this.getList()
		},
		backToList() {
			this.showDetail = false
			this.listDetail = {}
		}
	}
}
</script>
